<script setup>
import { computed, reactive, watch } from 'vue'
import { useApi } from '@provise/composables/api'

const props = defineProps({
  complaint: Object,
  step: String,
})
const sla = reactive({
  prog: 0,
  finDate: null, // formatted string
  started: false,
  finished: false, // formatted string (real finish)
  progbarOn: false,
  overdue: false,
  id: null,
  date_start: null, // Date obj
  date_finish: null, // Date obj
  slaLabelProgress: null,
  slaLabelDone: null,
  status: null,
})

defineExpose({ sla, extend })

watch(
  () => [props.complaint, props.step],
  ([c, step]) => {
    const ups = upsla(c, step)
    Object.assign(sla, ups)
  },
  { immediate: true }
)

const slaEntUrl = computed(() => {
  return `complaints/${props.complaint.id}/sla/${sla.id}`
})

const { model: slaent, refresh: upSlaEnt } = useApi({
  url: slaEntUrl,
  before: () => Boolean(props.complaint.id && sla.id),
})

async function extend(val) {
  slaent.value = val
  await upSlaEnt({ method: 'put' })
}
</script>
<script>
import steps from '@/views/complaints/item/steps.js'
import mustache from 'mustache'
import { differenceInDays, parseJSON } from 'date-fns'
import { commons } from '@provise/lib/transformer'

const defaultLabels = {
  // not recommended changin these keys
  slaLabelProgress: 'Завершить до {{date_finish}}',
  slaLabelDone: 'Завершено {{date_real_finish}}',
}

/**
 *
 * @param complaint
 * @param step
 * @returns {Object}
 */
export function upsla(complaint, step) {
  const sla = {}
  const currsla = (complaint.sla_complaint || []).find(sla => {
    return sla.status == step
  })

  if (!currsla) {
    return sla
  }

  sla.id = currsla.id
  sla.date_finish = parseJSON(currsla.date_finish)
  sla.date_start = parseJSON(currsla.date_start)
  sla.started = Boolean(currsla.date_start)
  sla.finished = commons.dateLocal(currsla.date_real_finish, 'Pp')
  sla.finDate = commons.dateLocal(currsla.date_finish, 'Pp')
  sla.progbarOn = !sla.finished
  sla.assign_user = currsla.assign_user
  sla.current_step = complaint.status.key == currsla.status
  sla.status = currsla.status

  /*-----*/

  const slaLabels = ['Done', 'Progress']
  for (let l of slaLabels) {
    l = `slaLabel${l}`
    let lbl = steps[step][l]
    if (!lbl) {
      lbl = defaultLabels[l]
    }
    sla[l] = mustache.render(lbl, { date_finish: sla.finDate, date_real_finish: sla.finished })
  }

  /*-----*/

  if (!(sla.progbarOn && sla.started)) {
    return sla
  }

  const fin = parseJSON(currsla.date_finish)
  const str = parseJSON(currsla.date_start)
  const now = new Date()

  const done = now.valueOf() - str.valueOf()
  const total = fin.valueOf() - str.valueOf()
  const prog = done / total

  sla.overdue = prog >= 1 || differenceInDays(fin, str) < 0
  sla.prog = sla.overdue ? 100 : prog * 100
  sla.color = sla.finished ? 'primary' : 'success'
  if (sla.prog >= 34) {
    sla.color = 'warning'
  }
  if (sla.prog >= 68) {
    sla.color = 'danger'
  }
  return sla
}
</script>
<template>
  <slot name="default" v-bind="{ sla }" />
</template>
